var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiGenial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 24C1.5 29.9674 3.87053 35.6903 8.0901 39.9099C12.3097 44.1295 18.0326 46.5 24 46.5C29.9674 46.5 35.6903 44.1295 39.9099 39.9099C44.1295 35.6903 46.5 29.9674 46.5 24C46.5 18.0326 44.1295 12.3097 39.9099 8.0901C35.6903 3.87053 29.9674 1.5 24 1.5C18.0326 1.5 12.3097 3.87053 8.0901 8.0901C3.87053 12.3097 1.5 18.0326 1.5 24V24Z",
    stroke: "#209670",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.732 28.5C36.9719 28.5 37.2084 28.5576 37.4215 28.668C37.6345 28.7783 37.818 28.9381 37.9566 29.1341C38.0951 29.33 38.1846 29.5563 38.2175 29.794C38.2505 30.0317 38.226 30.2738 38.146 30.5C37.1136 33.4272 35.1986 35.962 32.665 37.755C30.1313 39.5481 27.1039 40.5109 24 40.5109C20.8961 40.5109 17.8686 39.5481 15.335 37.755C12.8014 35.962 10.8863 33.4272 9.85398 30.5C9.77399 30.2738 9.74945 30.0317 9.7824 29.794C9.81536 29.5563 9.90486 29.33 10.0434 29.1341C10.1819 28.9381 10.3654 28.7783 10.5785 28.668C10.7916 28.5576 11.028 28.5 11.268 28.5H36.732Z",
    stroke: "#209670",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C13.8655 14.0329 12.3354 15.818 10.5 17.25C12.3354 18.682 13.8655 20.4671 15 22.5C16.1345 20.4671 17.6646 18.682 19.5 17.25C17.6646 15.818 16.1345 14.0329 15 12",
    stroke: "#209670",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 12C31.8655 14.0329 30.3354 15.818 28.5 17.25C30.3354 18.682 31.8655 20.4671 33 22.5C34.1345 20.4671 35.6646 18.682 37.5 17.25C35.6646 15.818 34.1345 14.0329 33 12",
    stroke: "#209670",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiGenial);
export default __webpack_public_path__ + "static/media/emoji-genial.fde4963cea08ac47829c4488a70eaf8b.svg";
export { ForwardRef as ReactComponent };